import {
  Marker as MapMarker,
  Tooltip

} from 'react-leaflet'

import L from 'leaflet'

// Pushes the label clear of the 50x50 icon on whichever side it sits.
const tooltipOffsets = {
  top: [0, -20],
  bottom: [0, 20],
  left: [-20, 0],
  right: [20, 0]
}

export default function Marker ({ popupText, location, iconUrl, goToMarker, tooltipDirection = 'top' }) {
  const icon = L.icon({ iconUrl, iconSize: [50, 50] })
  const eventHandlers = { click: goToMarker }
  return (
    <MapMarker position={location} icon={icon}>
      <Tooltip direction={tooltipDirection} offset={tooltipOffsets[tooltipDirection]} eventHandlers={eventHandlers} interactive permanent>
        <div className='p-1'>
          {popupText}
        </div>
      </Tooltip>
    </MapMarker>
  )
}
